import styled from 'styled-components';

export const RequiredLabel = styled.span<{ required?: boolean }>`
  margin-left: 0.25rem;
  color: ${({ theme }) => theme.colors.error};
`;
